import interrupt from "../interrupt.js";
export default function (name) {
  return this.each(function () {
    interrupt(this, name);
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-transition@1.3.2@d3-transition/src/selection/interrupt.js
// module id = 459
// module chunks = 0